var HOT_COUNT = 800, HOT_SPAN = 16, nativeNow = Date.now;
function shortOut(func) {
  var count = 0, lastCalled = 0;
  return function() {
    var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
    if (lastCalled = stamp, remaining > 0) {
      if (++count >= HOT_COUNT)
        return arguments[0];
    } else
      count = 0;
    return func.apply(void 0, arguments);
  };
}
export {
  shortOut as default
};
//# sourceMappingURL=_shortOut.js.map
